import { OrderItemType } from '../../../types/api/OrderTypes';
import { CartProducts, CartProductType } from '../../../types/state/reducers/cartReducersTypes';

export function getProductIds(products: CartProducts): number[] {
  return Object.keys(products).map((num) => Number(num));
}

export function productAlreadyInCart(products: CartProducts, selectedVariant: any): boolean {
  if (!products)
    return false
  const cartItems = [];
  Object.keys(products).forEach((key: string) => cartItems.push(products[key]));
  if (!cartItems.length)
    return false;
  return cartItems.some(
    (cartItem: CartProductType) => cartItem.id === selectedVariant.id && cartItem.resolution === selectedVariant.resolution
  );
}
